jQuery(document).ready(function($){

	setTimeout(function() {
        $('.woocommerce-message').fadeOut('');
		$('.woocommerce-error').fadeOut('');
    }, 5000);

	$(document).on('DOMNodeInserted', function(e) {
        if ($(e.target).is('.woocommerce-message')) {

           setTimeout(function() {
             $('.woocommerce-message').fadeOut('');
           }, 5000);
        }
		
		if ($(e.target).is('.woocommerce-error')) {

           setTimeout(function() {
             $('.woocommerce-error').fadeOut('');
           }, 5000);
        }
		
		//Add loading to Proceed to checkout in mini-cart
		$(".widget_shopping_cart .button.checkout").click(function() {
			$(this).addClass('loading');
		});	
    });

});
